import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: "Does this work if we haven't spoken in years?",
    answer: 'Yes. Years of silence often build a "fear of the first talk." We use the Soft Anchor script to make that first talk feel tiny and safe.'
  }, {
    question: 'What if they told me never to contact them again?',
    answer: 'The guide covers the "Respectful Distance" strategy, showing you how to honor that boundary while still leaving a very small, open door for the future.'
  }, {
    question: 'Can I send this to my adult child?',
    answer: 'No. This is for you. This is your private internal playbook to change the dynamic from your end first.'
  }, {
    question: 'Will this make me look weak?',
    answer: 'It makes you look like the adult in the room. There is immense power in being the one who refuses to keep fighting.'
  }];
  return <section className="py-20 bg-brand-sage" data-id="element-1">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-4">
            Questions You Might Have
          </h2>
          <div className="w-16 h-1 bg-brand-gold mx-auto rounded-full opacity-50" data-id="element-5"></div>
        </div>

        <div className="space-y-4" data-id="element-6">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-7" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-brand-cream rounded-2xl overflow-hidden shadow-sm transition-all duration-300" data-id="element-8">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={isOpen} data-id="element-9">
        <span className="font-heading font-semibold text-lg text-brand-navy pr-8" data-id="element-10">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-brand-gold flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-11" />
      </button>

      <div className={`px-6 transition-all duration-300 ease-in-out overflow-hidden ${isOpen ? 'max-h-48 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-12">
        <p className="text-brand-body leading-relaxed" data-id="element-13">{answer}</p>
      </div>
    </div>;
}